module.exports = __webpack_public_path__ + "static/media/mobile_dicero_page_area02_img_cn.2a9b9816.png";